<template>
  <div
    v-if="cashback"
    class="d-flex justify-center success--text"
    :class="containerClass"
  >
    <dt
      class="mr-1"
      :class="labelClass"
    >
      Cashback
    </dt>
    <dd
      v-if="cashbackUnit === 'points'"
      :class="labelClass"
    >
      {{ `${cashback} ${cashbackUnit}` }}
    </dd>
    <dd
      v-else
      :class="labelClass"
    >
      {{ `${cashbackUnit}${cashback.toFixed(2)}` }}
    </dd>
  </div>
</template>

<script>
export default {
  name: 'results-price-cashback',
  props: {
    cashback: {
      type: Number,
      default: null,
    },
    cashbackUnit: {
      type: String,
      default: null,
    },
    styleVariant: {
      type: String,
      default: 'default',
    },
  },
  computed: {
    containerClass () {
      return this.styleVariant === 'info' ? 'mb-3' : null;
    },
    labelClass () {
      return this.styleVariant === 'info' ? 'fs-22' : 'fs-13';
    },
  },
};
</script>
